export const RESET_PASSWORD_GUID = 'resetPasswordGuid';
